import { MantineProvider, createTheme } from '@mantine/core';
import { ChatApp } from './components/ChatApp';
import { Analytics } from '@vercel/analytics/react';
import '@mantine/core/styles.css';

const theme = createTheme({
  /** Put your mantine theme override here */
  primaryColor: 'blue',
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
  headings: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
  },
});

export function App() {
  return (
    <MantineProvider theme={theme}>
      <ChatApp />
      <Analytics />
    </MantineProvider>
  );
}